import { DEFAULT_RRULE_DAYS_STATE } from "@/consts";
import type { RRuleState } from "@/types";

export default (startDate?: number): RRuleState => {
  return {
    startDate,
    cadence: 1,
    occurence: 1,
    days: { ...DEFAULT_RRULE_DAYS_STATE },
    repeatAmount: 1,
    dayOrder: undefined,
    daySelection: undefined,
    endingType: undefined,
  };
};
